import React, { useState, useEffect } from 'react';
import { getUserId } from '../../utils/userId';

export const TestPaymentPage: React.FC = () => {
  const [userId, setUserId] = useState<string>('loading...');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    try {
      const id = getUserId();
      setUserId(id);
      console.log('TestPaymentPage 加载完成，用户ID:', id);
    } catch (error) {
      console.error('获取用户ID失败:', error);
      setUserId('error');
    }
  }, []);

  const handleDirectPayment = (productId: string, productName: string) => {
    console.log('直接支付按钮被点击:', { productId, productName });
    setIsLoading(true);
    
    try {
      const paymentUrl = `https://www.creem.io/payment/${productId}?customer_id=${encodeURIComponent(userId)}&success_url=${encodeURIComponent('https://sleepcalc-pro.pages.dev/?payment=success')}&cancel_url=${encodeURIComponent('https://sleepcalc-pro.pages.dev/?payment=cancel')}`;
      
      console.log('跳转到支付页面:', paymentUrl);
      window.location.href = paymentUrl;
    } catch (error) {
      console.error('支付跳转失败:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-8">支付按钮测试页面</h1>
        
        <div className="space-y-6">
          <div className="text-center">
            <p className="text-gray-600 mb-4">
              用户ID: <code className="bg-gray-100 px-2 py-1 rounded text-sm">{userId}</code>
            </p>
          </div>
          
          <div className="grid gap-4">
            <div className="border border-gray-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-4">SleepCalc Pro - 月付</h3>
              <p className="text-gray-600 mb-4">$4.99/月 - 高级睡眠优化功能</p>
              <button 
                onClick={() => handleDirectPayment('prod_10w6tRy1qlvUVAkyiDgX7E', 'SleepCalc Pro Monthly')}
                disabled={isLoading}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {isLoading ? '跳转中...' : '升级到 Pro 月付 ($4.99)'}
              </button>
              <p className="text-xs text-gray-500 mt-2">产品ID: prod_10w6tRy1qlvUVAkyiDgX7E</p>
            </div>
            
            <div className="border border-blue-500 rounded-lg p-6 bg-blue-50">
              <h3 className="text-xl font-semibold mb-4">SleepCalc Pro - 年付 (推荐)</h3>
              <p className="text-gray-600 mb-4">$39.00/年 - 相比月付节省 $80.88</p>
              <button 
                onClick={() => handleDirectPayment('prod_2mKSW1peZ6P7A1MpZNlcdc', 'SleepCalc Pro Annual')}
                disabled={isLoading}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {isLoading ? '跳转中...' : '升级到 Pro 年付 ($39.00)'}
              </button>
              <p className="text-xs text-gray-500 mt-2">产品ID: prod_2mKSW1peZ6P7A1MpZNlcdc</p>
            </div>
          </div>
          
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h4 className="font-semibold text-yellow-800 mb-2">测试说明:</h4>
            <ol className="text-yellow-700 space-y-1 text-sm">
              <li>1. 打开浏览器开发者工具 (F12)</li>
              <li>2. 点击上方的支付按钮</li>
              <li>3. 查看控制台调试信息</li>
              <li>4. 按钮应该跳转到 Creem 支付页面</li>
            </ol>
          </div>
          
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h4 className="font-semibold text-green-800 mb-2">预期结果:</h4>
            <ul className="text-green-700 space-y-1 text-sm">
              <li>• 月付按钮 → https://www.creem.io/payment/prod_10w6tRy1qlvUVAkyiDgX7E</li>
              <li>• 年付按钮 → https://www.creem.io/payment/prod_2mKSW1peZ6P7A1MpZNlcdc</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};